import IconButton from '@mui/material/IconButton';
import { t } from 'i18next';
import { useCollection, useJsonAPI } from 'json-api-hooks';
import React, { FC, useContext } from 'react';
import FontAwesome from 'react-fontawesome';
import { useNavigate } from 'react-router';

import { CollectionContext } from '../../components/./Collection/Collection';
import { CollectionCreateSingleButton } from '../../components/./Collection/CollectionCreateButton';
import CollectionTable from '../../components/./Collection/CollectionTable';
import { Section } from '../../components/App/typescript';
import ContainerHeader from '../../components/Container/ContainerHeader';
import RelativeDate from '../../components/RelativeDate';
import { Column } from '../../components/Table';
import EventStreetForm from '../../forms/EventStreetForm';
import useModalDispatch from '../../hooks/useModalDispatch';
import { tryParseDate } from '../../lib/date';
import { formatNumber } from '../../lib/formatters';
import retrievePath from '../../lib/iris';
import DeleteResourceModal from '../../modals/DeleteResourceModal';
import { EventStreetResource } from '../../models';

const DeleteButton = ({ item }: { item: EventStreetResource }) => {
  const openModal = useModalDispatch(DeleteResourceModal);
  const handleClick = () =>
    openModal({
      description: 'Weet je zeker dat je deze straat wilt verwijderen?',
      resource: item,
      label: 'Straat verwijderen',
    });

  return (
    <IconButton aria-label="Verwijderen" size="small" onClick={handleClick}>
      <FontAwesome name="times" />
    </IconButton>
  );
};

const columns: Column<'event_streets'>[] = [
  {
    label: t('table.streets.columns.name'),
    attribute: 'name',
  },
  {
    label: t('table.streets.columns.lastVisitedAt'),
    attribute: 'lastVisitedAt',
    render: ({ attributes: { lastVisitedAt } }) => <RelativeDate date={tryParseDate(lastVisitedAt)} />,
  },
  {
    label: t('table.streets.columns.pendingAddressesCount'),
    attribute: 'pendingAddressesCount',
    render: ({ attributes: { pendingAddressesCount } }) => formatNumber(pendingAddressesCount),
  },
];
const adminColumns: Column<'event_streets'>[] = [
  ...columns,
  {
    label: t('table.streets.columns.destroy'),
    attribute: 'destroyAction',
    render: (item) => <DeleteButton item={item} />,
  },
];

const EventStreetTable: FC<{ admin?: boolean; eventId: string }> = ({ admin, eventId }) => {
  const navigate = useNavigate();
  const { router } = useJsonAPI();
  const { collectionOpts, resourceType } = useContext(CollectionContext);
  const [items] = useCollection(resourceType, collectionOpts);

  const handleRowClick = (eventStreet: EventStreetResource) => {
    navigate(retrievePath(router.resourceRoute(eventStreet.relationships.street.data)));
  };

  return (
    <>
      {(admin || items.length > 0) && (
        <ContainerHeader
          float={
            admin ? (
              <CollectionCreateSingleButton
                defaultValues={{ eventId }}
                form={EventStreetForm}
                label="Straat toevoegen"
                type="event_streets"
              />
            ) : undefined
          }
          title="Straten"
        />
      )}
      <CollectionTable<'event_streets'>
        columns={admin ? adminColumns : columns}
        onEmpty={() => (GLOBALS.section === Section.Admin ? <p>Nog geen straten toegevoegd</p> : null)}
        onRowClick={admin ? undefined : handleRowClick}
      />
    </>
  );
};

export default EventStreetTable;
